export default __webpack_public_path__ + "static/media/ethereum.23097e39.png";